import axios from 'axios';
import { Site } from 'views/order-feed/types/site.type';

// GET
// SAP: /ewosapi/v1/order/sites/simple/${customerErpId}
export const getSites = async (customerErpId: string): Promise<Site[]> => {
  const res = await axios.get<Site[]>(`/ewosapi/v1/order/sites/simple/${customerErpId}`);
  return res.data;
};
